import { useEffect, useRef } from 'react';
import { useAuth as useClerkAuth, useUser } from '@clerk/clerk-react';

import { useAnalytics } from '~/context/analytics';

export function UserDataLayer() {
  const { isLoaded: clerkLoaded, isSignedIn: clerkSignedIn } = useClerkAuth();
  const { user: clerkUser } = useUser();
  const { gtm } = useAnalytics();
  const lastPushedKey = useRef<string | null>(null);

  useEffect(() => {
    if (!clerkLoaded) return;

    if (!clerkSignedIn) {
      if (lastPushedKey.current === 'signed-out') return;
      lastPushedKey.current = 'signed-out';
      gtm.push({ event: 'user_data', logged_in: false });
      return;
    }

    const asfId = clerkUser?.publicMetadata?.asfId as string | undefined;
    if (!asfId) return;

    const key = `signed-in:${asfId}`;
    if (lastPushedKey.current === key) return;
    lastPushedKey.current = key;
    gtm.push({ event: 'user_data', logged_in: true, user_id: asfId });
  }, [clerkLoaded, clerkSignedIn, clerkUser, gtm]);

  return null;
}
